import React, { useEffect } from "react";
import { useStateMachine } from "little-state-machine";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { useGetQuickRequestDetails } from "api/queries/quick-request/useGetQuickRequestDetails";
import CardNew from "components/molecules/Card/CardNew";
import LoadingSkeleton from "components/atoms/LoadingSkeleton/LoadingSkeleton";
import usePermissions from "hooks/usePermissions";
import Alert from "components/molecules/Alert/Alert";
import ShipmentTrackingV2 from "pages/common/ShipmentTrackingV2/ShipmentTrackingV2";

const SHIPMENT_STATUS = ["Delayed", "In transit", "Incomplete", "Delivered", "Auto-closed", "Booked", "Cancelled"];

function QuickTracking() {
  const { state } = useStateMachine();
  const navigate = useNavigate();
  const { permissions } = usePermissions();

  const { data: quickDetailsData, isLoading } = useGetQuickRequestDetails(state.shipmentId, {
    enabled: !!state.shipmentId,
    refetchOnMount: false,
  });

  useEffect(() => {
    if (!JSON.parse(permissions || "{}")?.permissions?.tracking?.view_shipments) navigate("/access-denied");
  }, []);

  const isRelatedRequestIsShipment = () =>
    quickDetailsData?.related_request?.related_request_id &&
    SHIPMENT_STATUS.includes(quickDetailsData?.related_request?.related_request_status);

  return (
    <>
      {isLoading && (
        <CardNew className="w-100 border-radius-top-0">
          <LoadingSkeleton rows={1} noShadow isListing />
        </CardNew>
      )}
      {!isLoading && isRelatedRequestIsShipment() && (
        <ShipmentTrackingV2 isQuickRequest shipmentId={quickDetailsData.related_request.related_request_id} />
      )}
      {!isLoading && !isRelatedRequestIsShipment() && (
        <Alert className="mb-0 mt-4" variant="danger">
          <FormattedMessage
            id="quote-request.couldNotRetrieveDetailsMsg"
            defaultMessage="We could not retrieve any details. Please try again. If you continue to have trouble please contact admin."
          />
        </Alert>
      )}
    </>
  );
}

export default QuickTracking;
